export const SET_NICKNAME_BY_TOKEN_REQUESTED =
  "SET_NICKNAME_BY_TOKEN_REQUESTED";
export const SET_NICKNAME_BY_TOKEN_FULFILLED =
  "SET_NICKNAME_BY_TOKEN_FULFILLED";
export const SET_NICKNAME_BY_TOKEN_REJECTED = "SET_NICKNAME_BY_TOKEN_REJECTED";
